import React from 'react';
interface IconProps {
  width?: number;
  height?: number;
}
const OutLineInfoIcon = (props: IconProps) => {
  const { width = '12', height = '12' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
        stroke="#0088FF"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00195 6.00195V8.69426"
        stroke="#0088FF"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.93831 4.33854C6.11674 4.33854 6.26139 4.19389 6.26139 4.01546C6.26139 3.83703 6.11674 3.69238 5.93831 3.69238C5.75988 3.69238 5.61523 3.83703 5.61523 4.01546C5.61523 4.19389 5.75988 4.33854 5.93831 4.33854Z"
        fill="black"
        stroke="#0088FF"
        strokeWidth="0.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OutLineInfoIcon;
